import { useCallback, useRef } from 'react';
import { scrollTo } from 'utils';

export default function useScrollIntoView(offset = 0) {
  const container = useRef<HTMLDivElement>(null);

  const scrollToStart = useCallback(() => {
    if (!container.current) return;

    // `offset` lets callers keep the target clear of a sticky header.
    scrollTo({
      top: Math.max(container.current.offsetTop - offset, 0),
      left: container.current.offsetLeft,
    });
  }, [offset]);

  return [container, scrollToStart] as const;
}
